import React, { FC } from 'react';
import { push } from 'redux-first-history';
import { ArrowDropDownIcon, PrimaryButton, SimplePopover } from '@dev/ee-components';
import { generateIdBasedOnPath, safelyEncodeBase64Url } from '@dev/ee-tools';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import useMobile from '@/services/hooks/useMobile';
import { ALL_CONTACTS_SEGMENT } from '@/services/constants';
import { ContactsPaths, pathsParams } from '@/services/dictionaries/Paths';

import { useRouteMatch } from 'react-router';
import { useSelectedEntity } from '../../../../hooks';
import { ArrowDropdownContainer } from '../../../StyledComponents';

export const AddContactsButton: FC = (): JSX.Element => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const isMobile = useMobile();
    const { isAllContactsSegment, getDisplayName } = useSelectedEntity();
    const route = useRouteMatch();
    const selectedName = getDisplayName(ALL_CONTACTS_SEGMENT);

    const onClickButton = () => {
        const path = isAllContactsSegment ? ContactsPaths.SegmentAdd : ContactsPaths.ListAdd;
        const pathParam = isAllContactsSegment ? pathsParams.segmentName : pathsParams.listName;
        dispatch(push(path.replace(pathParam, safelyEncodeBase64Url(selectedName))));
    };

    if (isMobile) {
        return <PrimaryButton id="add-contacts-button" text={t('addcontactsbtn')} onClick={onClickButton} />;
    }

    const idStaticPath = route?.path
        ?.replace(pathsParams.segmentName, isAllContactsSegment ? 'all-contacts' : 'single-segment')
        .replace(pathsParams?.listName, 'single-list');

    const dropdownOptions = [
        {
            label: t('uploadcontacts'),
            value: 'upload',
            id: generateIdBasedOnPath('dropdown-upload-contacts', idStaticPath),
        },
        {
            label: t('addcontact'),
            value: 'add',
            id: generateIdBasedOnPath('dropdown-add-contact', idStaticPath),
        },
    ];

    const onClickDropdownItem = (_e: any, obj: { value: any }): void => {
        const addPath = isAllContactsSegment ? ContactsPaths.SegmentAdd : ContactsPaths.ListAdd;
        const uploadPath = isAllContactsSegment ? ContactsPaths.SegmentUpload : ContactsPaths.ListUpload;
        const pathParam = isAllContactsSegment ? pathsParams.segmentName : pathsParams.listName;

        dispatch(
            push(
                obj.value === 'add'
                    ? addPath.replace(pathParam, safelyEncodeBase64Url(selectedName))
                    : uploadPath.replace(pathParam, safelyEncodeBase64Url(selectedName))
            )
        );
    };

    return (
        <SimplePopover
            id={generateIdBasedOnPath('add-contacts', idStaticPath)}
            type="custom"
            onItemClick={onClickDropdownItem}
            options={dropdownOptions}
            placement="bottom-end"
        >
            <PrimaryButton
                id={generateIdBasedOnPath('add-contacts-button', route?.path)}
                endIcon={
                    <ArrowDropdownContainer>
                        <ArrowDropDownIcon color="white" />
                    </ArrowDropdownContainer>
                }
                text={t('addcontactsbtn')}
            />
        </SimplePopover>
    );
};
